import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  public photo: string | undefined;

  // constructor() {}

  public async takePhoto(): Promise<void> {
    const hasPermission = await this.checkCameraPermission();

    if (!hasPermission) {
      throw new Error('PERMISSION_DENIED');
      // console.error('Permiso de cámara no concedido');
      // return;
    }

    try {
      const image = await Camera.getPhoto({
        quality: 80,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Camera,

        correctOrientation: true,
        width: 3000,
        height: 3000,
      });
      this.photo = image.dataUrl; // base64 format with "data:image/jpeg;base64,"
    } catch (error) {
      console.error(`Error: ${error}`);
      throw error;
      // console.error('Error en la foto, cancelado por el usuario o rechazado por el sistema', error);
    }
  }

  public async getPhotoFromGallery(): Promise<void> {
    const hasPermission = await this.checkGalleryPermission();

    if (!hasPermission) {
      console.error('Permiso de galería no concedido');
      return;
    }

    try {
      const image = await Camera.getPhoto({
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Photos,
        quality: 80,
        correctOrientation: true,
        width: 3000,
        height: 3000,
      });
      this.photo = image.dataUrl; // base64 format with "data:image/jpeg;base64,"
    } catch (error) {
      console.error('Error al seleccionar el archivo:', error);
    }
  }

  public clearPhoto(): void {
    this.photo = undefined;
  }

  private async checkCameraPermission(): Promise<boolean> {
    const status = await Camera.checkPermissions();

    if (status.camera === 'denied' || status.camera === 'prompt') {
      const result = await Camera.requestPermissions();
      return result.camera === 'granted';
    }

    return status.camera === 'granted';
  }

  private async checkGalleryPermission(): Promise<boolean> {
    const status = await Camera.checkPermissions();

    if (status.photos === 'denied' || status.photos === 'prompt') {
      const result = await Camera.requestPermissions();
      return result.photos === 'granted';
    }

    return status.photos === 'granted';
  }
}
